var _rect, _rect2, _rect3, _rect4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgQrMobile = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 110,
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 110,
    height: 110,
    rx: 8,
    fill: "#5D21D2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 110,
    height: 110,
    rx: 8,
    fill: "url(#paint0_radial_1_5293)",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 110,
    height: 110,
    rx: 8,
    fill: "url(#paint1_radial_1_5293)",
    fillOpacity: 0.29
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 110,
    height: 110,
    rx: 8,
    fill: "url(#paint2_radial_1_5293)",
    fillOpacity: 0.26
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5393 14.8584C42.9508 14.8584 43.2824 14.5267 43.2824 14.1152V14.8584H42.5393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7712 14.1194V12.1084C46.7712 11.6969 46.4395 11.3652 46.0281 11.3652H44.0212C43.6098 11.3652 43.2781 11.6969 43.2781 12.1084V14.8584H46.767V14.1153L46.7712 14.1194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9924 14.8584C60.4039 14.8584 60.7356 14.5267 60.7356 14.1152V14.8584H59.9924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2244 14.1194V12.1084C64.2244 11.6969 63.8927 11.3652 63.4812 11.3652H61.4743C61.0629 11.3652 60.7312 11.6969 60.7312 12.1084V14.8584H64.2202V14.1153L64.2244 14.1194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4634 11.3652H68.4607C68.0502 11.3652 67.7175 11.6979 67.7175 12.1084V14.1111C67.7175 14.5215 68.0502 14.8542 68.4607 14.8542H70.4634C70.8738 14.8542 71.2065 14.5215 71.2065 14.1111V12.1084C71.2065 11.6979 70.8738 11.3652 70.4634 11.3652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5393 14.8584H40.5324C40.121 14.8584 39.7893 15.1901 39.7893 15.6015V17.6084C39.7893 18.0199 40.121 18.3515 40.5324 18.3515H43.2825V14.8626H42.5393V14.8584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7712 14.8584H43.2822V18.3474H46.7712V14.8584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5212 18.3515C49.9327 18.3515 50.2644 18.0199 50.2644 17.6084V18.3515H49.5212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5144 18.3515C47.1029 18.3515 46.7712 18.0199 46.7712 17.6084V18.3515H47.5144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0034 14.8584C50.5919 14.8584 50.2603 15.1901 50.2603 15.6015V18.3515H53.7492V14.8626H50.9992L51.0034 14.8584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2424 14.8584H53.7534V18.3474H57.2424V14.8584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7355 14.8584H57.2466V18.3474H60.7355V14.8584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2244 17.6086C64.2244 18.0201 63.8927 18.3517 63.4812 18.3517H60.7312V14.8628H64.2202V17.6128L64.2244 17.6086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2824 19.0903V18.3472H42.5393C42.9508 18.3472 43.2824 18.6788 43.2824 19.0903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5393 21.8403C42.9508 21.8403 43.2824 21.5086 43.2824 21.0972V21.8403H42.5393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7712 18.3516H43.2822V21.8405H46.7712V18.3516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2602 18.3516H46.7712V21.8405H50.2602V18.3516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7534 18.3516H50.2644V21.8405H53.7534V18.3516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4966 18.3516H53.7534V19.0947C53.7534 18.6832 54.0851 18.3516 54.4966 18.3516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5393 21.8403H40.5324C40.121 21.8403 39.7893 22.172 39.7893 22.5835V24.5903C39.7893 25.0018 40.121 25.3335 40.5324 25.3335H43.2825V21.8445H42.5393V21.8403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7712 24.5905C46.7712 25.002 46.4395 25.3337 46.0281 25.3337H43.2781V21.8447H46.767V24.5947L46.7712 24.5905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5144 21.8403H46.7712V22.5835C46.7712 22.172 47.1029 21.8403 47.5144 21.8403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2644 22.5835V21.8403H49.5212C49.9327 21.8403 50.2644 22.172 50.2644 22.5835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2644 24.5903C50.2644 25.0018 50.5961 25.3335 51.0075 25.3335H53.0144C53.4259 25.3335 53.7576 25.0018 53.7576 24.5903V21.8403H50.2686V24.5903H50.2644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9924 21.8403H57.9897C57.5793 21.8403 57.2466 22.173 57.2466 22.5835V24.5862C57.2466 24.9966 57.5793 25.3293 57.9897 25.3293H59.9924C60.4028 25.3293 60.7355 24.9966 60.7355 24.5862V22.5835C60.7355 22.173 60.4028 21.8403 59.9924 21.8403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9675 21.8403C64.556 21.8403 64.2244 22.172 64.2244 22.5835V25.3335H67.7133V21.8445H64.9633L64.9675 21.8403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4634 21.8403C70.8748 21.8403 71.2065 22.172 71.2065 22.5835V25.3335H67.7175V21.8445H70.4675L70.4634 21.8403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2644 28.0796V26.0727C50.2644 25.6613 49.9327 25.3296 49.5213 25.3296H47.5144C47.1029 25.3296 46.7712 25.6613 46.7712 26.0727V28.8227H50.2602V28.0796H50.2644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4992 25.3296H54.4966C54.0861 25.3296 53.7534 25.6623 53.7534 26.0727V28.0754C53.7534 28.4858 54.0861 28.8185 54.4966 28.8185H56.4992C56.9097 28.8185 57.2424 28.4858 57.2424 28.0754V26.0727C57.2424 25.6623 56.9097 25.3296 56.4992 25.3296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4856 28.8227C63.897 28.8227 64.2287 28.491 64.2287 28.0796V28.8227H63.4856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7133 25.3296H64.2244V28.8185H67.7133V25.3296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2065 28.0793C71.2065 28.4908 70.8749 28.8224 70.4634 28.8224H67.7134V25.3335H71.2023V28.0835L71.2065 28.0793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2825 31.5684V29.5615C43.2825 29.15 42.9508 28.8184 42.5393 28.8184H40.5324C40.121 28.8184 39.7893 29.15 39.7893 29.5615V32.3115H43.2783V31.5684H43.2825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2602 28.8228H46.7712V32.3117H50.2602V28.8228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9924 28.8228H57.9856C57.5741 28.8228 57.2424 29.1544 57.2424 29.5659V31.5728C57.2424 31.9842 57.5741 32.3159 57.9856 32.3159H60.7356V28.827H59.9924V28.8228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2245 28.8228H60.7356V32.3117H64.2245V28.8228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7175 31.5686C67.7175 31.98 67.3858 32.3117 66.9744 32.3117H64.2244V28.8228H67.7133V31.5728L67.7175 31.5686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4565 28.8228H67.7134V29.5659C67.7134 29.1544 68.0451 28.8228 68.4565 28.8228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7935 35.0615C39.7935 35.473 40.1251 35.8047 40.5366 35.8047H42.5435C42.9549 35.8047 43.2866 35.473 43.2866 35.0615V32.3115H39.7977V35.0615H39.7935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7712 35.0615C46.7712 35.473 47.1029 35.8047 47.5144 35.8047H49.5213C49.9327 35.8047 50.2644 35.473 50.2644 35.0615V32.3115H46.7754V35.0615H46.7712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2466 35.0615V33.0547C57.2466 32.6432 56.9149 32.3115 56.5034 32.3115H54.4966C54.0851 32.3115 53.7534 32.6432 53.7534 33.0547V35.8047H57.2424V35.0615H57.2466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7356 33.0547V32.3115H59.9924C60.4039 32.3115 60.7356 32.6432 60.7356 33.0547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7356 35.0615C60.7356 35.473 61.0673 35.8047 61.4787 35.8047H63.4856C63.8971 35.8047 64.2287 35.473 64.2287 35.0615V32.3115H60.7398V35.0615H60.7356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9675 32.3115H64.2244V33.0547C64.2244 32.6432 64.556 32.3115 64.9675 32.3115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2065 35.0615V33.0547C71.2065 32.6432 70.8749 32.3115 70.4634 32.3115H68.4565C68.0451 32.3115 67.7134 32.6432 67.7134 33.0547V35.8047H71.2023V35.0615H71.2065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2424 35.8003H53.7534V39.2892H57.2424V35.8003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7175 38.5503C67.7175 38.9618 68.0492 39.2934 68.4607 39.2934H70.4675C70.879 39.2934 71.2107 38.9618 71.2107 38.5503V35.8003H67.7217V38.5503H67.7175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6081 39.2935C12.1967 39.2935 11.865 39.6251 11.865 40.0366V42.7866H15.3539V39.2977H12.6081V39.2935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8471 39.2935H15.3582V42.7824H18.8471V39.2935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3403 39.2935H18.8513V42.7824H22.3403V39.2935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8293 39.2935H22.3403V42.7824H25.8293V39.2935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5793 39.2935C28.9908 39.2935 29.3224 39.6251 29.3224 40.0366V42.7866H25.8335V39.2977H28.5835L28.5793 39.2935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5613 39.2935H33.5544C33.143 39.2935 32.8113 39.6251 32.8113 40.0366V42.0435C32.8113 42.4549 33.143 42.7866 33.5544 42.7866H36.3044V39.2977H35.5613V39.2935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7892 39.2935H36.3003V42.7824H39.7892V39.2935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2824 39.2935H39.7935V42.7824H43.2824V39.2935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7712 39.2935H43.2822V42.7824H46.7712V39.2935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5144 42.7827H49.5213C49.9327 42.7827 50.2644 42.451 50.2644 42.0396V40.0327C50.2644 39.6212 49.9327 39.2896 49.5213 39.2896H46.7712V42.7785H47.5144V42.7827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7534 42.0396C53.7534 42.451 54.0851 42.7827 54.4966 42.7827H56.5034C56.9149 42.7827 57.2466 42.451 57.2466 42.0396V39.2896H53.7576V42.0396H53.7534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4787 39.2935C61.0673 39.2935 60.7356 39.6251 60.7356 40.0366V42.7866H64.2245V39.2977H61.4745L61.4787 39.2935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9746 39.2935C67.386 39.2935 67.7177 39.6251 67.7177 40.0366V42.7866H64.2288V39.2977H66.9788L66.9746 39.2935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4634 42.7827C70.8748 42.7827 71.2065 42.451 71.2065 42.0396V42.7827H70.4634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4565 42.7827C68.0451 42.7827 67.7134 42.451 67.7134 42.0396V42.7827H68.4565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6955 42.0396V40.0327C74.6955 39.6212 74.3639 39.2896 73.9524 39.2896H71.9455C71.5341 39.2896 71.2024 39.6212 71.2024 40.0327V42.7827H74.6913V42.0396H74.6955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6777 42.0396V40.0327C81.6777 39.6212 81.346 39.2896 80.9346 39.2896H78.9277C78.5162 39.2896 78.1846 39.6212 78.1846 40.0327V42.7827H81.6735V42.0396H81.6777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4209 42.7827C82.0094 42.7827 81.6777 42.451 81.6777 42.0396V42.7827H82.4209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9123 39.2935H85.9096C85.4992 39.2935 85.1665 39.6262 85.1665 40.0366V42.0393C85.1665 42.4497 85.4992 42.7824 85.9096 42.7824H87.9123C88.3227 42.7824 88.6555 42.4497 88.6555 42.0393V40.0366C88.6555 39.6262 88.3227 39.2935 87.9123 39.2935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8945 39.2935H92.8918C92.4814 39.2935 92.1487 39.6262 92.1487 40.0366V42.0393C92.1487 42.4497 92.4814 42.7824 92.8918 42.7824H94.8945C95.3049 42.7824 95.6376 42.4497 95.6376 42.0393V40.0366C95.6376 39.6262 95.3049 39.2935 94.8945 39.2935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.865 45.5327C11.865 45.9442 12.1967 46.2759 12.6081 46.2759H14.615C15.0265 46.2759 15.3581 45.9442 15.3581 45.5327V42.7827H11.865V45.5327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1013 42.7827H15.3582V43.5258C15.3582 43.1144 15.6898 42.7827 16.1013 42.7827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8513 43.5258V42.7827H18.1082C18.5196 42.7827 18.8513 43.1144 18.8513 43.5258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8513 45.5327C18.8513 45.9442 19.183 46.2759 19.5945 46.2759H21.6013C22.0128 46.2759 22.3445 45.9442 22.3445 45.5327V42.7827H18.8555V45.5327H18.8513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0835 42.7827H22.3403V43.5258C22.3403 43.1144 22.672 42.7827 23.0835 42.7827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8291 43.5258V42.7827H25.0859C25.4974 42.7827 25.8291 43.1144 25.8291 43.5258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0903 46.2715C25.5018 46.2715 25.8335 45.9398 25.8335 45.5283V46.2715H25.0903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3181 42.7827H25.8291V46.2717H29.3181V42.7827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0612 46.2715C29.6498 46.2715 29.3181 45.9398 29.3181 45.5283V46.2715H30.0612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3003 43.5258V42.7827H35.5571C35.9686 42.7827 36.3003 43.1144 36.3003 43.5258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3003 45.5327C36.3003 45.9442 36.632 46.2759 37.0434 46.2759H39.0503C39.4618 46.2759 39.7934 45.9442 39.7934 45.5327V42.7827H36.3045V45.5327H36.3003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5324 42.7827H39.7893V43.5258C39.7893 43.1144 40.121 42.7827 40.5324 42.7827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2824 43.5258V42.7827H42.5393C42.9508 42.7827 43.2824 43.1144 43.2824 43.5258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7712 42.7827H43.2822V46.2717H46.7712V42.7827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5144 42.7827H46.7712V43.5258C46.7712 43.1144 47.1029 42.7827 47.5144 42.7827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9924 46.2715C60.4039 46.2715 60.7356 45.9398 60.7356 45.5283V46.2715H59.9924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2245 42.7827H60.7356V46.2717H64.2245V42.7827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7133 42.7827H64.2244V46.2717H67.7133V42.7827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2065 42.7827H67.7175V46.2717H71.2065V42.7827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6955 42.7827H71.2065V46.2717H74.6955V42.7827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4387 46.2715C75.0272 46.2715 74.6956 45.9398 74.6956 45.5283V46.2715H75.4387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1887 45.5324C78.1887 45.9439 78.5204 46.2756 78.9319 46.2756H81.6819V42.7866H78.1929V45.5366L78.1887 45.5324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4277 42.7827C84.8392 42.7827 85.1708 43.1144 85.1708 43.5258V46.2759H81.6819V42.7869H84.4319L84.4277 42.7827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3835 42.7827H96.3808C95.9704 42.7827 95.6377 43.1154 95.6377 43.5258V45.5285C95.6377 45.939 95.9704 46.2717 96.3808 46.2717H98.3835C98.7939 46.2717 99.1266 45.939 99.1266 45.5285V43.5258C99.1266 43.1154 98.7939 42.7827 98.3835 42.7827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.104 46.2715H16.1013C15.6909 46.2715 15.3582 46.6042 15.3582 47.0146V49.0173C15.3582 49.4277 15.6909 49.7604 16.1013 49.7604H18.104C18.5144 49.7604 18.8471 49.4277 18.8471 49.0173V47.0146C18.8471 46.6042 18.5144 46.2715 18.104 46.2715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0835 46.2715C22.672 46.2715 22.3403 46.6032 22.3403 47.0146V49.7646H25.8293V46.2757H23.0793L23.0835 46.2715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3181 46.2715H25.8291V49.7604H29.3181V46.2715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8112 46.2715H29.3223V49.7604H32.8112V46.2715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5544 49.7646H35.5613C35.9727 49.7646 36.3044 49.433 36.3044 49.0215V47.0146C36.3044 46.6032 35.9727 46.2715 35.5613 46.2715H32.8113V49.7604H33.5544V49.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7712 46.2715H43.2822V49.7604H46.7712V46.2715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5212 49.7646C49.9327 49.7646 50.2644 49.4329 50.2644 49.0215V49.7646H49.5212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5144 49.7646C47.1029 49.7646 46.7712 49.4329 46.7712 49.0215V49.7646H47.5144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0034 46.2715C50.5919 46.2715 50.2603 46.6032 50.2603 47.0146V49.7646H53.7492V46.2757H50.9992L51.0034 46.2715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2424 46.2715H53.7534V49.7604H57.2424V46.2715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7355 46.2715H57.2466V49.7604H60.7355V46.2715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2245 46.2715H60.7356V49.7604H64.2245V46.2715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7175 49.0217C67.7175 49.4332 67.3858 49.7648 66.9744 49.7648H64.2244V46.2759H67.7133V49.0259L67.7175 49.0217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4565 46.2715H67.7134V47.0146C67.7134 46.6032 68.0451 46.2715 68.4565 46.2715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2065 47.0146V46.2715H70.4634C70.8748 46.2715 71.2065 46.6032 71.2065 47.0146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4634 49.7646C70.8748 49.7646 71.2065 49.4329 71.2065 49.0215V49.7646H70.4634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6955 46.2715H71.2065V49.7604H74.6955V46.2715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4387 49.7646H77.4456C77.857 49.7646 78.1887 49.433 78.1887 49.0215V47.0146C78.1887 46.6032 77.857 46.2715 77.4456 46.2715H74.6956V49.7604H75.4387V49.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6777 47.0146V46.2715H80.9346C81.346 46.2715 81.6777 46.6032 81.6777 47.0146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6777 49.0215C81.6777 49.433 82.0094 49.7646 82.4209 49.7646H84.4278C84.8392 49.7646 85.1709 49.433 85.1709 49.0215V46.2715H81.6819V49.0215H81.6777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4055 46.2715H89.4028C88.9924 46.2715 88.6597 46.6042 88.6597 47.0146V49.0173C88.6597 49.4277 88.9924 49.7604 89.4028 49.7604H91.4055C91.8159 49.7604 92.1486 49.4277 92.1486 49.0173V47.0146C92.1486 46.6042 91.8159 46.2715 91.4055 46.2715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3403 52.5103C22.3403 52.9217 22.672 53.2534 23.0835 53.2534H25.0903C25.5018 53.2534 25.8335 52.9217 25.8335 52.5103V49.7603H22.3445V52.5103H22.3403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5722 49.7646H25.8291V50.5078C25.8291 50.0963 26.1608 49.7646 26.5722 49.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3222 50.5034V49.7603H28.5791C28.9906 49.7603 29.3222 50.0919 29.3222 50.5034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3223 52.5103C29.3223 52.9217 29.6539 53.2534 30.0654 53.2534H32.0723C32.4837 53.2534 32.8154 52.9217 32.8154 52.5103V49.7603H29.3265V52.5103H29.3223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5544 49.7646H32.8113V50.5078C32.8113 50.0963 33.143 49.7646 33.5544 49.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0461 49.7646H37.0434C36.633 49.7646 36.3003 50.0974 36.3003 50.5078V52.5105C36.3003 52.9209 36.633 53.2536 37.0434 53.2536H39.0461C39.4565 53.2536 39.7892 52.9209 39.7892 52.5105V50.5078C39.7892 50.0974 39.4565 49.7646 39.0461 49.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7712 49.7646H43.2822V53.2536H46.7712V49.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2602 49.7646H46.7712V53.2536H50.2602V49.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7534 49.7646H50.2644V53.2536H53.7534V49.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4966 49.7646H53.7534V50.5078C53.7534 50.0963 54.0851 49.7646 54.4966 49.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7356 50.5034V49.7603H59.9924C60.4039 49.7603 60.7356 50.0919 60.7356 50.5034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7356 52.5103C60.7356 52.9217 61.0673 53.2534 61.4787 53.2534H63.4856C63.8971 53.2534 64.2287 52.9217 64.2287 52.5103V49.7603H60.7398V52.5103H60.7356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9675 49.7646H64.2244V50.5078C64.2244 50.0963 64.556 49.7646 64.9675 49.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4634 49.7646H68.4565C68.0451 49.7646 67.7134 50.0963 67.7134 50.5078V52.5147C67.7134 52.9261 68.0451 53.2578 68.4565 53.2578H71.2065V49.7688H70.4634V49.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6955 52.5105C74.6955 52.9219 74.3639 53.2536 73.9524 53.2536H71.2024V49.7646H74.6913V52.5147L74.6955 52.5105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4387 49.7646H74.6956V50.5078C74.6956 50.0963 75.0272 49.7646 75.4387 49.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6081 53.2534C12.1967 53.2534 11.865 53.5851 11.865 53.9966V56.7466H15.3539V53.2576H12.6081V53.2534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8471 53.2534H15.3582V56.7424H18.8471V53.2534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5903 56.7466H21.5972C22.0086 56.7466 22.3403 56.4149 22.3403 56.0034V53.9966C22.3403 53.5851 22.0086 53.2534 21.5972 53.2534H18.8472V56.7424H19.5903V56.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5571 53.2534H33.5544C33.144 53.2534 32.8113 53.5861 32.8113 53.9966V55.9992C32.8113 56.4097 33.144 56.7424 33.5544 56.7424H35.5571C35.9675 56.7424 36.3002 56.4097 36.3002 55.9992V53.9966C36.3002 53.5861 35.9675 53.2534 35.5571 53.2534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7712 53.2534H43.2822V56.7424H46.7712V53.2534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5144 53.2534H46.7712V53.9966C46.7712 53.5851 47.1029 53.2534 47.5144 53.2534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2644 53.9966V53.2534H49.5212C49.9327 53.2534 50.2644 53.5851 50.2644 53.9966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5144 56.747C47.1029 56.747 46.7712 56.4154 46.7712 56.0039V56.747H47.5144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2644 56.0034C50.2644 56.4149 50.5961 56.7466 51.0075 56.7466H53.0144C53.4259 56.7466 53.7576 56.4149 53.7576 56.0034V53.2534H50.2686V56.0034H50.2644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9924 53.2534H57.9897C57.5793 53.2534 57.2466 53.5861 57.2466 53.9966V55.9992C57.2466 56.4097 57.5793 56.7424 57.9897 56.7424H59.9924C60.4028 56.7424 60.7355 56.4097 60.7355 55.9992V53.9966C60.7355 53.5861 60.4028 53.2534 59.9924 53.2534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9702 53.2534H64.9675C64.5571 53.2534 64.2244 53.5861 64.2244 53.9966V55.9992C64.2244 56.4097 64.5571 56.7424 64.9675 56.7424H66.9702C67.3806 56.7424 67.7133 56.4097 67.7133 55.9992V53.9966C67.7133 53.5861 67.3806 53.2534 66.9702 53.2534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9565 56.747C74.368 56.747 74.6997 56.4154 74.6997 56.0039V56.747H73.9565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4387 53.2534C75.0272 53.2534 74.6956 53.5851 74.6956 53.9966V56.7466H78.1845V53.2576H75.4345L75.4387 53.2534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6777 53.2534H78.1887V56.7424H81.6777V53.2534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1667 53.2534H81.6777V56.7424H85.1667V53.2534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9096 56.7466H87.9165C88.328 56.7466 88.6597 56.4149 88.6597 56.0034V53.9966C88.6597 53.5851 88.328 53.2534 87.9165 53.2534H85.1665V56.7424H85.9096V56.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8987 53.2534H92.8918C92.4804 53.2534 92.1487 53.5851 92.1487 53.9966V56.0034C92.1487 56.4149 92.4804 56.7466 92.8918 56.7466H95.6418V53.2576H94.8987V53.2534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3808 56.7466H98.3877C98.7992 56.7466 99.1308 56.4149 99.1308 56.0034V53.9966C99.1308 53.5851 98.7992 53.2534 98.3877 53.2534H95.6377V56.7424H96.3808V56.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3539 56.7466H11.865V60.2355H15.3539V56.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1013 56.7466H15.3582V57.4897C15.3582 57.0783 15.6898 56.7466 16.1013 56.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2822 59.4924C43.2822 59.9039 43.6139 60.2355 44.0254 60.2355H46.7754V56.7466H43.2864V59.4966L43.2822 59.4924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5144 60.2358H49.5213C49.9327 60.2358 50.2644 59.9041 50.2644 59.4927V57.4858C50.2644 57.0744 49.9327 56.7427 49.5213 56.7427H46.7712V60.2316H47.5144V60.2358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4992 56.7466H54.4966C54.0861 56.7466 53.7534 57.0793 53.7534 57.4897V59.4924C53.7534 59.9028 54.0861 60.2355 54.4966 60.2355H56.4992C56.9097 60.2355 57.2424 59.9028 57.2424 59.4924V57.4897C57.2424 57.0793 56.9097 56.7466 56.4992 56.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4634 56.7466H68.4565C68.0451 56.7466 67.7134 57.0783 67.7134 57.4897V59.4966C67.7134 59.9081 68.0451 60.2397 68.4565 60.2397H71.2065V56.7508H70.4634V56.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6955 56.7466H71.2065V60.2355H74.6955V56.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1845 56.7466H74.6956V60.2355H78.1845V56.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6777 56.7466H78.1887V60.2355H81.6777V56.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1667 56.7466H81.6777V60.2355H85.1667V56.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9096 56.7466H85.1665V57.4897C85.1665 57.0783 85.4982 56.7466 85.9096 56.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3539 60.2358H11.865V63.7248H15.3539V60.2358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5971 60.2358H19.5945C19.184 60.2358 18.8513 60.5686 18.8513 60.979V62.9817C18.8513 63.3921 19.184 63.7248 19.5945 63.7248H21.5971C22.0076 63.7248 22.3403 63.3921 22.3403 62.9817V60.979C22.3403 60.5686 22.0076 60.2358 21.5971 60.2358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5791 60.2358H26.5722C26.1608 60.2358 25.8291 60.5675 25.8291 60.979V62.9859C25.8291 63.3973 26.1608 63.729 26.5722 63.729H29.3223V60.24H28.5791V60.2358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8112 60.2358H29.3223V63.7248H32.8112V60.2358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3002 60.2358H32.8113V63.7248H36.3002V60.2358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0503 60.2358C39.4617 60.2358 39.7934 60.5675 39.7934 60.979V63.729H36.3044V60.24H39.0545L39.0503 60.2358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5324 63.7246C40.121 63.7246 39.7893 63.3929 39.7893 62.9814V63.7246H40.5324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9924 60.2358H57.9897C57.5793 60.2358 57.2466 60.5686 57.2466 60.979V62.9817C57.2466 63.3921 57.5793 63.7248 57.9897 63.7248H59.9924C60.4028 63.7248 60.7355 63.3921 60.7355 62.9817V60.979C60.7355 60.5686 60.4028 60.2358 59.9924 60.2358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2065 60.979V60.2358H70.4634C70.8748 60.2358 71.2065 60.5675 71.2065 60.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6955 60.2358H71.2065V63.7248H74.6955V60.2358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1887 62.9856C78.1887 63.397 77.857 63.7287 77.4456 63.7287H74.6956V60.2397H78.1845V62.9898L78.1887 62.9856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9277 60.2358H78.1846V60.979C78.1846 60.5675 78.5162 60.2358 78.9277 60.2358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6777 60.979V60.2358H80.9346C81.346 60.2358 81.6777 60.5675 81.6777 60.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6777 62.9859C81.6777 63.3973 82.0094 63.729 82.4209 63.729H84.4278C84.8392 63.729 85.1709 63.3973 85.1709 62.9859V60.2358H81.6819V62.9859H81.6777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4055 60.2358H89.3987C88.9872 60.2358 88.6555 60.5675 88.6555 60.979V62.9859C88.6555 63.3973 88.9872 63.729 89.3987 63.729H92.1487V60.24H91.4055V60.2358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6376 60.2358H92.1487V63.7248H95.6376V60.2358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3877 60.2358C98.7991 60.2358 99.1308 60.5675 99.1308 60.979V63.729H95.6418V60.24H98.3919L98.3877 60.2358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3539 63.7246H11.865V67.2136H15.3539V63.7246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5972 67.2177C22.0086 67.2177 22.3403 66.8861 22.3403 66.4746V67.2177H21.5972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8291 66.4746V64.4677C25.8291 64.0563 25.4974 63.7246 25.086 63.7246H23.0791C22.6676 63.7246 22.3359 64.0563 22.3359 64.4677V67.2178H25.8249V66.4746H25.8291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3222 64.4677V63.7246H28.5791C28.9906 63.7246 29.3222 64.0563 29.3222 64.4677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3223 66.4746C29.3223 66.8861 29.6539 67.2178 30.0654 67.2178H32.0723C32.4837 67.2178 32.8154 66.8861 32.8154 66.4746V63.7246H29.3265V66.4746H29.3223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5544 63.7246H32.8113V64.4677C32.8113 64.0563 33.143 63.7246 33.5544 63.7246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3003 64.4677V63.7246H35.5571C35.9686 63.7246 36.3003 64.0563 36.3003 64.4677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5613 67.2177C35.9727 67.2177 36.3044 66.8861 36.3044 66.4746V67.2177H35.5613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7892 63.7246H36.3003V67.2136H39.7892V63.7246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5324 67.2178H42.5393C42.9508 67.2178 43.2825 66.8861 43.2825 66.4746V64.4677C43.2825 64.0563 42.9508 63.7246 42.5393 63.7246H39.7893V67.2136H40.5324V67.2178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2466 66.4746V64.4677C57.2466 64.0563 56.9149 63.7246 56.5034 63.7246H54.4966C54.0851 63.7246 53.7534 64.0563 53.7534 64.4677V67.2178H57.2424V66.4746H57.2466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9856 67.2177C57.5741 67.2177 57.2424 66.8861 57.2424 66.4746V67.2177H57.9856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4814 63.7246H61.4787C61.0683 63.7246 60.7356 64.0573 60.7356 64.4677V66.4704C60.7356 66.8809 61.0683 67.2136 61.4787 67.2136H63.4814C63.8918 67.2136 64.2245 66.8809 64.2245 66.4704V64.4677C64.2245 64.0573 63.8918 63.7246 63.4814 63.7246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4634 67.2177C70.8748 67.2177 71.2065 66.8861 71.2065 66.4746V67.2177H70.4634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6955 63.7246H71.2065V67.2136H74.6955V63.7246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4387 63.7246H74.6956V64.4677C74.6956 64.0563 75.0272 63.7246 75.4387 63.7246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4387 67.2177C75.0272 67.2177 74.6956 66.8861 74.6956 66.4746V67.2177H75.4387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1487 64.4677V63.7246H91.4055C91.817 63.7246 92.1487 64.0563 92.1487 64.4677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1487 66.4748C92.1487 66.8863 92.4804 67.218 92.8918 67.218H95.6418V63.729H92.1529V66.479L92.1487 66.4748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1266 63.7246H95.6377V67.2136H99.1266V63.7246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.865 69.9639C11.865 70.3753 12.1967 70.707 12.6081 70.707H14.615C15.0265 70.707 15.3581 70.3753 15.3581 69.9639V67.2139H11.865V69.9639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5972 67.2178H19.5903C19.1788 67.2178 18.8472 67.5495 18.8472 67.9609V69.9678C18.8472 70.3792 19.1788 70.7109 19.5903 70.7109H22.3403V67.222H21.5972V67.2178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8291 69.9636C25.8291 70.375 25.4974 70.7067 25.086 70.7067H22.3359V67.2178H25.8249V69.9678L25.8291 69.9636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5613 67.2178H33.5544C33.143 67.2178 32.8113 67.5495 32.8113 67.9609V69.9678C32.8113 70.3792 33.143 70.7109 33.5544 70.7109H36.3044V67.222H35.5613V67.2178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7934 69.9636C39.7934 70.375 39.4618 70.7067 39.0503 70.7067H36.3003V67.2178H39.7892V69.9678L39.7934 69.9636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5324 67.2178H39.7893V67.9609C39.7893 67.5495 40.121 67.2178 40.5324 67.2178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5171 67.2178H47.5144C47.104 67.2178 46.7712 67.5505 46.7712 67.9609V69.9636C46.7712 70.374 47.104 70.7067 47.5144 70.7067H49.5171C49.9275 70.7067 50.2602 70.374 50.2602 69.9636V67.9609C50.2602 67.5505 49.9275 67.2178 49.5171 67.2178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7534 69.9636C53.7534 70.375 54.0851 70.7067 54.4966 70.7067H57.2466V67.2178H53.7576V69.9678L53.7534 69.9636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9856 70.707H59.9924C60.4039 70.707 60.7356 70.3753 60.7356 69.9639V67.957C60.7356 67.5455 60.4039 67.2139 59.9924 67.2139H57.2424V70.7028H57.9856V70.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9744 67.2178H64.9675C64.556 67.2178 64.2244 67.5495 64.2244 67.9609V69.9678C64.2244 70.3792 64.556 70.7109 64.9675 70.7109H67.7175V67.222H66.9744V67.2178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2065 67.2178H67.7175V70.7067H71.2065V67.2178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6955 67.2178H71.2065V70.7067H74.6955V67.2178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1845 67.2178H74.6956V70.7067H78.1845V67.2178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6777 67.2178H78.1887V70.7067H81.6777V67.2178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1667 67.2178H81.6777V70.7067H85.1667V67.2178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9096 70.707H87.9165C88.328 70.707 88.6597 70.3753 88.6597 69.9639V67.957C88.6597 67.5455 88.328 67.2139 87.9165 67.2139H85.1665V70.7028H85.9096V70.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6377 67.957V67.2139H94.8945C95.306 67.2139 95.6377 67.5455 95.6377 67.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1266 67.2178H95.6377V70.7067H99.1266V67.2178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5324 70.707C40.121 70.707 39.7893 71.0387 39.7893 71.4502V74.2002H43.2783V70.7112H40.5282L40.5324 70.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0324 70.707C46.4439 70.707 46.7756 71.0387 46.7756 71.4502V74.2002H43.2866V70.7112H46.0366L46.0324 70.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5144 74.1958C47.1029 74.1958 46.7712 73.8641 46.7712 73.4526V74.1958H47.5144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2244 73.457V71.4502C64.2244 71.0387 63.8927 70.707 63.4812 70.707H61.4743C61.0629 70.707 60.7312 71.0387 60.7312 71.4502V74.2002H64.2202V73.457H64.2244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7175 71.4502V70.707H66.9744C67.3858 70.707 67.7175 71.0387 67.7175 71.4502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2065 70.707H67.7175V74.196H71.2065V70.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9497 70.707H71.2065V71.4502C71.2065 71.0387 71.5382 70.707 71.9497 70.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6777 71.4502V70.707H80.9346C81.346 70.707 81.6777 71.0387 81.6777 71.4502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1667 70.707H81.6777V74.196H85.1667V70.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9096 70.707H85.1665V71.4502C85.1665 71.0387 85.4982 70.707 85.9096 70.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8987 74.1958C95.3101 74.1958 95.6418 73.8641 95.6418 73.4526V74.1958H94.8987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1266 70.707H95.6377V74.196H99.1266V70.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7935 76.946C39.7935 77.3575 40.1251 77.6891 40.5366 77.6891H43.2866V74.2002H39.7977V76.9502L39.7935 76.946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7712 74.1958H43.2822V77.6848H46.7712V74.1958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2602 74.1958H46.7712V77.6848H50.2602V74.1958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7534 74.1958H50.2644V77.6848H53.7534V74.1958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4966 77.689H56.5034C56.9149 77.689 57.2466 77.3573 57.2466 76.9458V74.9389C57.2466 74.5275 56.9149 74.1958 56.5034 74.1958H53.7534V77.6848H54.4966V77.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2245 74.1958H60.7356V77.6848H64.2245V74.1958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2065 74.1958H67.7175V77.6848H71.2065V74.1958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4414 74.1958H75.4387C75.0283 74.1958 74.6956 74.5285 74.6956 74.9389V76.9416C74.6956 77.352 75.0283 77.6848 75.4387 77.6848H77.4414C77.8518 77.6848 78.1845 77.352 78.1845 76.9416V74.9389C78.1845 74.5285 77.8518 74.1958 77.4414 74.1958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1667 74.1958H81.6777V77.6848H85.1667V74.1958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9096 77.6889C85.4982 77.6889 85.1665 77.3573 85.1665 76.9458V77.6889H85.9096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4055 74.1958H89.3987C88.9872 74.1958 88.6555 74.5275 88.6555 74.9389V76.9458C88.6555 77.3573 88.9872 77.689 89.3987 77.689H92.1487V74.2H91.4055V74.1958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6376 74.1958H92.1487V77.6848H95.6376V74.1958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1308 76.946C99.1308 77.3575 98.7992 77.6891 98.3877 77.6891H95.6377V74.2002H99.1266V76.9502L99.1308 76.946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2824 78.4277V77.6846H42.5393C42.9508 77.6846 43.2824 78.0162 43.2824 78.4277Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5393 81.1777C42.9508 81.1777 43.2824 80.846 43.2824 80.4346V81.1777H42.5393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7712 77.689H43.2822V81.1779H46.7712V77.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5144 77.689H46.7712V78.4321C46.7712 78.0206 47.1029 77.689 47.5144 77.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2644 78.4277V77.6846H49.5212C49.9327 77.6846 50.2644 78.0162 50.2644 78.4277Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7534 77.689H50.2644V81.1779H53.7534V77.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4966 77.689H53.7534V78.4321C53.7534 78.0206 54.0851 77.689 54.4966 77.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4966 81.1777C54.0851 81.1777 53.7534 80.846 53.7534 80.4346V81.1777H54.4966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9924 81.1777C60.4039 81.1777 60.7356 80.846 60.7356 80.4346V81.1777H59.9924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2245 77.689H60.7356V81.1779H64.2245V77.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2065 77.689H67.7175V81.1779H71.2065V77.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9497 81.1777C71.5382 81.1777 71.2065 80.846 71.2065 80.4346V81.1777H71.9497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9346 81.1777C81.346 81.1777 81.6777 80.846 81.6777 80.4346V81.1777H80.9346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1667 77.689H81.6777V81.1779H85.1667V77.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9167 77.689C88.3282 77.689 88.6599 78.0206 88.6599 78.4321V81.1821H85.1709V77.6932H87.9209L87.9167 77.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5324 81.1777C40.121 81.1777 39.7893 81.5094 39.7893 81.9209V84.6709H43.2783V81.1819H40.5282L40.5324 81.1777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7712 83.928C46.7712 84.3394 46.4395 84.6711 46.0281 84.6711H43.2781V81.1821H46.767V83.9321L46.7712 83.928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2644 83.928C50.2644 84.3394 50.5961 84.6711 51.0075 84.6711H53.7576V81.1821H50.2686V83.9321L50.2644 83.928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2424 81.1777H53.7534V84.6667H57.2424V81.1777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7355 81.1777H57.2466V84.6667H60.7355V81.1777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2245 81.1777H60.7356V84.6667H64.2245V81.1777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9744 84.667C67.3858 84.667 67.7175 84.3353 67.7175 83.9238V84.667H66.9744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9675 84.667C64.556 84.667 64.2244 84.3353 64.2244 83.9238V84.667H64.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2065 81.1777H67.7175V84.6667H71.2065V81.1777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6955 81.1777H71.2065V84.6667H74.6955V81.1777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1845 81.1777H74.6956V84.6667H78.1845V81.1777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6777 81.1777H78.1887V84.6667H81.6777V81.1777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1667 81.1777H81.6777V84.6667H85.1667V81.1777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6597 83.928C88.6597 84.3394 88.328 84.6711 87.9165 84.6711H85.1665V81.1821H88.6555V83.9321L88.6597 83.928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2824 84.667H39.7935V88.1559H43.2824V84.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0254 84.667H43.2822V85.4101C43.2822 84.9987 43.6139 84.667 44.0254 84.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7534 85.4101V84.667H53.0103C53.4217 84.667 53.7534 84.9987 53.7534 85.4101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2424 84.667H53.7534V88.1559H57.2424V84.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9856 84.667H57.2424V85.4101C57.2424 84.9987 57.5741 84.667 57.9856 84.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7356 85.4101V84.667H59.9924C60.4039 84.667 60.7356 84.9987 60.7356 85.4101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9856 88.1601C57.5741 88.1601 57.2424 87.8284 57.2424 87.417V88.1601H57.9856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7356 87.4167C60.7356 87.8282 61.0673 88.1599 61.4787 88.1599H64.2287V84.6709H60.7398V87.4209L60.7356 87.4167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7133 84.667H64.2244V88.1559H67.7133V84.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2065 87.4167C71.2065 87.8282 70.8749 88.1599 70.4634 88.1599H67.7134V84.6709H71.2023V87.4209L71.2065 87.4167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9497 84.667H71.2065V85.4101C71.2065 84.9987 71.5382 84.667 71.9497 84.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6955 85.4101V84.667H73.9524C74.3638 84.667 74.6955 84.9987 74.6955 85.4101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6956 87.417C74.6956 87.8285 75.0272 88.1601 75.4387 88.1601H77.4456C77.857 88.1601 78.1887 87.8285 78.1887 87.417V84.667H74.6998V87.417H74.6956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9277 84.667H78.1846V85.4101C78.1846 84.9987 78.5162 84.667 78.9277 84.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6777 85.4101V84.667H80.9346C81.346 84.667 81.6777 84.9987 81.6777 85.4101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1667 84.667H81.6777V88.1559H85.1667V84.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9096 84.667H85.1665V85.4101C85.1665 84.9987 85.4982 84.667 85.9096 84.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8987 84.667H92.8918C92.4804 84.667 92.1487 84.9987 92.1487 85.4101V87.417C92.1487 87.8285 92.4804 88.1601 92.8918 88.1601H95.6418V84.6712H94.8987V84.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3877 84.667C98.7991 84.667 99.1308 84.9987 99.1308 85.4101V88.1601H95.6418V84.6712H98.3919L98.3877 84.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2824 88.1602H39.7935V91.6491H43.2824V88.1602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5171 88.1602H47.5144C47.104 88.1602 46.7712 88.4929 46.7712 88.9033V90.906C46.7712 91.3164 47.104 91.6491 47.5144 91.6491H49.5171C49.9275 91.6491 50.2602 91.3164 50.2602 90.906V88.9033C50.2602 88.4929 49.9275 88.1602 49.5171 88.1602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2424 88.1602H53.7534V91.6491H57.2424V88.1602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9856 91.6489H59.9924C60.4039 91.6489 60.7356 91.3172 60.7356 90.9058V88.8989C60.7356 88.4874 60.4039 88.1558 59.9924 88.1558H57.2424V91.6447H57.9856V91.6489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9346 91.6489C81.346 91.6489 81.6777 91.3172 81.6777 90.9058V91.6489H80.9346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1667 88.1602H81.6777V91.6491H85.1667V88.1602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9096 91.6489C85.4982 91.6489 85.1665 91.3172 85.1665 90.9058V91.6489H85.9096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4055 88.1602H89.4028C88.9924 88.1602 88.6597 88.4929 88.6597 88.9033V90.906C88.6597 91.3164 88.9924 91.6491 89.4028 91.6491H91.4055C91.8159 91.6491 92.1486 91.3164 92.1486 90.906V88.9033C92.1486 88.4929 91.8159 88.1602 91.4055 88.1602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6377 88.8989V88.1558H94.8945C95.306 88.1558 95.6377 88.4874 95.6377 88.8989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6377 90.9058C95.6377 91.3172 95.9694 91.6489 96.3808 91.6489H98.3877C98.7992 91.6489 99.1308 91.3172 99.1308 90.9058V88.1558H95.6419V90.9058H95.6377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2824 91.6489H39.7935V95.1379H43.2824V91.6489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7534 94.3989C53.7534 94.8104 54.0851 95.1421 54.4966 95.1421H56.5034C56.9149 95.1421 57.2466 94.8104 57.2466 94.3989V91.6489H53.7576V94.3989H53.7534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9856 91.6489H57.2424V92.3921C57.2424 91.9806 57.5741 91.6489 57.9856 91.6489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4814 91.6489H61.4787C61.0683 91.6489 60.7356 91.9816 60.7356 92.3921V94.3947C60.7356 94.8052 61.0683 95.1379 61.4787 95.1379H63.4814C63.8918 95.1379 64.2245 94.8052 64.2245 94.3947V92.3921C64.2245 91.9816 63.8918 91.6489 63.4814 91.6489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4634 91.6489H68.4565C68.0451 91.6489 67.7134 91.9806 67.7134 92.3921V94.3989C67.7134 94.8104 68.0451 95.1421 68.4565 95.1421H71.2065V91.6531H70.4634V91.6489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6955 91.6489H71.2065V95.1379H74.6955V91.6489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1845 91.6489H74.6956V95.1379H78.1845V91.6489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6777 91.6489H78.1887V95.1379H81.6777V91.6489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1667 91.6489H81.6777V95.1379H85.1667V91.6489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9096 95.1377H87.9165C88.328 95.1377 88.6597 94.806 88.6597 94.3945V92.3877C88.6597 91.9762 88.328 91.6445 87.9165 91.6445H85.1665V95.1335H85.9096V95.1377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4055 95.1377C91.817 95.1377 92.1487 94.806 92.1487 94.3945V95.1377H91.4055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6377 94.3989V92.3921C95.6377 91.9806 95.306 91.6489 94.8945 91.6489H92.8877C92.4762 91.6489 92.1445 91.9806 92.1445 92.3921V95.1421H95.6335V94.3989H95.6377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3808 95.1377C95.9694 95.1377 95.6377 94.806 95.6377 94.3945V95.1377H96.3808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7935 97.8877C39.7935 98.2992 40.1251 98.6308 40.5366 98.6308H42.5435C42.9549 98.6308 43.2866 98.2992 43.2866 97.8877V95.1377H39.7977V97.8877H39.7935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5171 95.1377H47.5144C47.104 95.1377 46.7712 95.4704 46.7712 95.8808V97.8835C46.7712 98.2939 47.104 98.6266 47.5144 98.6266H49.5171C49.9275 98.6266 50.2602 98.2939 50.2602 97.8835V95.8808C50.2602 95.4704 49.9275 95.1377 49.5171 95.1377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9702 95.1377H64.9675C64.5571 95.1377 64.2244 95.4704 64.2244 95.8808V97.8835C64.2244 98.2939 64.5571 98.6266 64.9675 98.6266H66.9702C67.3806 98.6266 67.7133 98.2939 67.7133 97.8835V95.8808C67.7133 95.4704 67.3806 95.1377 66.9702 95.1377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4055 95.1377H89.3987C88.9872 95.1377 88.6555 95.4694 88.6555 95.8808V97.8877C88.6555 98.2992 88.9872 98.6308 89.3987 98.6308H92.1487V95.1419H91.4055V95.1377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6376 95.1377H92.1487V98.6266H95.6376V95.1377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3808 98.6308H98.3877C98.7992 98.6308 99.1308 98.2992 99.1308 97.8877V95.8808C99.1308 95.4694 98.7992 95.1377 98.3877 95.1377H95.6377V98.6266H96.3808V98.6308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6081 11.3652C12.2009 11.3652 11.865 11.7011 11.865 12.1084V35.0616C11.865 35.4688 12.1967 35.8047 12.6081 35.8047H35.5613C35.9686 35.8047 36.3045 35.473 36.3045 35.0616V12.1084C36.3045 11.7011 35.9728 11.3652 35.5613 11.3652H12.6081ZM32.8113 18.3515V31.8875C32.8113 32.1268 32.6182 32.3115 32.3873 32.3115H15.7864C15.5471 32.3115 15.3623 32.1184 15.3623 31.8875V15.2866C15.3623 15.0473 15.5555 14.8626 15.7864 14.8626H32.3873C32.6266 14.8626 32.8113 15.0557 32.8113 15.2866V18.3515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3224 25.3293V19.0903C29.3224 18.683 28.9907 18.3472 28.5793 18.3472H19.5903C19.183 18.3472 18.8472 18.6788 18.8472 19.0903V28.0835C18.8472 28.4907 19.1788 28.8266 19.5903 28.8266H28.5793C28.9865 28.8266 29.3224 28.4949 29.3224 28.0835V25.3335V25.3293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4387 11.3652C75.0314 11.3652 74.6956 11.7011 74.6956 12.1084V35.0616C74.6956 35.4688 75.0272 35.8047 75.4387 35.8047H98.3919C98.7991 35.8047 99.135 35.473 99.135 35.0616V12.1084C99.135 11.7011 98.8033 11.3652 98.3919 11.3652H75.4387ZM95.6419 18.3515V31.8875C95.6419 32.1268 95.4487 32.3115 95.2178 32.3115H78.617C78.3776 32.3115 78.1929 32.1184 78.1929 31.8875V15.2866C78.1929 15.0473 78.386 14.8626 78.617 14.8626H95.2178C95.4571 14.8626 95.6419 15.0557 95.6419 15.2866V18.3515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1486 25.3293V19.0903C92.1486 18.683 91.8169 18.3472 91.4055 18.3472H82.4165C82.0092 18.3472 81.6733 18.6788 81.6733 19.0903V28.0835C81.6733 28.4907 82.005 28.8266 82.4165 28.8266H91.4055C91.8127 28.8266 92.1486 28.4949 92.1486 28.0835V25.3335V25.3293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6081 74.1914C12.2009 74.1914 11.865 74.5273 11.865 74.9345V97.8877C11.865 98.295 12.1967 98.6309 12.6081 98.6309H35.5613C35.9686 98.6309 36.3045 98.2992 36.3045 97.8877V74.9345C36.3045 74.5273 35.9728 74.1914 35.5613 74.1914H12.6081ZM32.8113 81.1777V94.7137C32.8113 94.953 32.6182 95.1377 32.3873 95.1377H15.7864C15.5471 95.1377 15.3623 94.9446 15.3623 94.7137V78.1128C15.3623 77.8735 15.5555 77.6888 15.7864 77.6888H32.3873C32.6266 77.6888 32.8113 77.8819 32.8113 78.1128V81.1777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3224 88.1598V81.9209C29.3224 81.5136 28.9907 81.1777 28.5793 81.1777H19.5903C19.183 81.1777 18.8472 81.5094 18.8472 81.9209V90.9141C18.8472 91.3213 19.1788 91.6572 19.5903 91.6572H28.5793C28.9865 91.6572 29.3224 91.3255 29.3224 90.9141V88.164V88.1598Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_5293",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.0002 -20.5563) rotate(91.1855) scale(130.584 132.528)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F86FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F86FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_5293",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.69601 88.8107) rotate(-57.7487) scale(105.012 248.295)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFB9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1_5293",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.5 130.933) rotate(-124.882) scale(122.189 327.875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.27,
    height: 87.27,
    fill: "white",
    transform: "translate(11.865 11.3652)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQrMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/qr-mobile.caf16cb6ec932c58a1fec86ce28eee5c.svg";